<template>
    <div id="content">
        <div class="inner">
          <add-button v-if="$route.name === 'batchList' && $_createActionAllowed" :title="'Nový dávkový import MAC adres' | translate" route-name="registeredMacAddressBatchNew"></add-button>
            <h1 v-translate>Správa MAC adres</h1>
        </div>
      <div class="responsiveTabs">
        <ul class="tabs">
          <li :class="{'r-tabs-state-active' : this.$route.name === 'batchList'}"><a
              @click.stop="openRoute('batchList')" v-translate>Seznam importů</a></li>
          <li :class="{'r-tabs-state-active' : this.$route.name === 'macAddressList'}"><a
              @click.stop="openRoute('macAddressList')" v-translate>Seznam registrovaných MAC adres</a></li>
          <li :class="{'r-tabs-state-active' : this.$route.name === 'unregisteredMacAddressList'}"><a
              @click.stop="openRoute('unregisteredMacAddressList')" v-translate>Seznam neregistrovaných MAC adres</a></li>
        </ul>
        </div>
      <keep-alive>
        <router-view
        />
      </keep-alive>
    </div>
</template>

<script>
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "RegisteredMacAddress",
    mixins: [listActions],
    methods: {
      openRoute(routerName) {
        this.$router.push({
          name: routerName
        })
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressBatchList.vue